export default __webpack_public_path__ + "static/media/02.e95fbbcb.png";